import { Outlet, useLoaderData } from "react-router-dom";
import { TabClientNotes } from "../../../../components/cm/Dashboard/FullPages/ClientDetail/TabClientNotesCallLog/TabClientNotes";
import AppWrapper from "../../../../components/cm/AppWrapper";
import SideBarMain from "../../../../components/cm/SideBarMain";

export default () => {
  const { _case } = useLoaderData();

  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain/>}>
      <div className="grid grid-cols-[70%_30%] w-auto min-w-[800px] gap-4">
          <div className="bg-white rounded-xl mt-6">
            <Outlet />
          </div>
        <TabClientNotes caseObj={_case}/>
      </div>
    </AppWrapper.WithSidebar>
  );
};
